import { Link } from 'react-router-dom';
import { team } from '@/mocks/site';

export default function TeamPreview() {
  return (
    <section id="team" className="py-24 md:py-32 bg-warm scroll-mt-[96px]">
      <div className="max-w-container mx-auto px-5 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 max-w-editorial">
          <div className="max-w-text">
            <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-cocoa">Our Team</div>
            <h2 className="mt-3 font-display font-bold text-[44px] md:text-[58px] leading-[1.02] text-cocoa">
              The people who will care for your pet.
            </h2>
          </div>
          <Link to="/about" className="inline-flex items-center gap-2 text-[15px] font-semibold text-cocoa hover:text-careDark cursor-pointer whitespace-nowrap">
            Meet the Team
            <i className="ri-arrow-right-line text-[16px]"></i>
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {team.map((m) => (
            <div key={m.name}>
              <div className="relative w-full aspect-[4/5] overflow-hidden rounded-[36px] bg-line border border-line">
                <img
                  src={m.img}
                  alt={m.name}
                  decoding="async"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
              </div>
              <div className="mt-5">
                <h3 className="font-display font-semibold text-[24px] text-cocoa">{m.name}</h3>
                <p className="mt-1 text-[14px] text-muted">{m.credential}</p>
                <p className="mt-2 text-[15px] text-ink/80">{m.specialty}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}